<template>
   <div class="container py-5">
      <h1 class="display-6 text-center">Exam Boards we cover</h1>
     
    <div class="card border-success mb-4">
  <div class="card-header bg-success text-white fw-bold">
    Exam Boards Covered
  </div>
  <div class="card-body">
    <h5 class="card-title">UK & International Curricula</h5>
    <p class="card-text">
      We specialize in delivering Computer Science support tailored to the following boards:
    </p>

    <ul class="list-group list-group-flush">
      <li class="list-group-item">📘 OCR – GCSE & A-Level</li>
      <li class="list-group-item">📗 AQA – GCSE & A-Level</li>
      <li class="list-group-item">📙 Edexcel – GCSE & A-Level</li>
      <li class="list-group-item">📕 Cambridge – IGCSE & A-Level</li>
      <li class="list-group-item">🌐 IB – International Baccalaureate (MYP & IBDP)</li>
    </ul>
  </div>
</div>
    </div>
</template>